const MAX_HOUR = 23;
const TIME_REGEX = /^[\d:,.\s\-apmAPM]*$/;

export function isValidTimeInput(inputValue: string): boolean {
  if (!inputValue.trim()) {
    return false;
  }

  const hasInvalidChars = !TIME_REGEX.test(inputValue);
  if (hasInvalidChars) {
    return false;
  }

  const digitsOnly = inputValue.replace(/\D/g, '');
  const hasNoDigits = digitsOnly.length === 0;
  if (hasNoDigits) {
    return false;
  }

  const digitsToValidate =
    digitsOnly.length === 3 ? `0${digitsOnly}` : digitsOnly;

  const hasInvalidHour =
    digitsToValidate.length >= 2 &&
    parseInt(digitsToValidate.substring(0, 2), 10) > MAX_HOUR;
  if (hasInvalidHour) {
    return false;
  }

  return true;
}
